import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL e Anon Key são obrigatórios');
}

// Validar formato da URL
try {
  new URL(supabaseUrl);
} catch (error) {
  throw new Error('URL do Supabase inválida');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'Content-Type': 'application/json'
    }
  }
});

// Tipos do banco de dados
export interface Profile {
  id: string;
  email: string;
  full_name: string | null;
  avatar_url: string | null;
  role: string;
  created_at: string;
  updated_at: string;
}

export interface Startup {
  id: string;
  name: string;
  description: string | null;
  stage: string;
  sector: string | null;
  website: string | null;
  email: string | null;
  phone: string | null;
  logo_url: string | null;
  founded_date: string | null;
  team_size: number | null;
  revenue: number | null;
  funding_raised: number | null;
  status: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface CRMDeal {
  id: string;
  user_id: string;
  title: string;
  company_name: string;
  contact_name: string;
  contact_email?: string;
  contact_phone?: string;
  value: number;
  stage: string;
  probability?: number;
  expected_close_date?: string;
  notes?: string;
  status?: string;
  source?: string;
  created_at: string;
  updated_at: string;
  // ✅ NOVOS CAMPOS DE COMISSÃO
  brought_by?: string;
  brought_by_name?: string;
  commission_percentage?: number;
  commission_value?: number;
  commission_paid?: boolean;
  commission_paid_date?: string;
}

export interface Evento {
  id: string;
  title: string;
  description: string | null;
  type: string | null;
  date: string;
  end_date: string | null;
  location: string | null;
  online: boolean;
  meeting_link: string | null;
  capacity: number | null;
  registered_count: number;
  status: string;
  banner_url: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface Parceiro {
  id: string;
  company_name: string;
  contact_name: string | null;
  email: string | null;
  phone: string | null;
  partnership_type: string | null;
  status: string;
  benefits: string | null;
  logo_url: string | null;
  website: string | null;
  contract_start: string | null;
  contract_end: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface Investidor {
  id: string;
  name: string;
  type: string | null;
  email: string | null;
  phone: string | null;
  investment_range_min: number | null;
  investment_range_max: number | null;
  sectors_interest: string[] | null;
  stage_preference: string[] | null;
  portfolio_companies: number | null;
  website: string | null;
  linkedin_url: string | null;
  status: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface Mentor {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  expertise: string[] | null;
  bio: string | null;
  linkedin_url: string | null;
  avatar_url: string | null;
  available: boolean;
  rating: number | null;
  sessions_count: number;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface Automation {
  id: string;
  name: string;
  description: string | null;
  trigger_type: string;
  trigger_config: any;
  actions: any;
  status: string;
  executions_count: number;
  success_count: number;
  last_execution: string | null;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}

export interface Comunicacao {
  id: string;
  title: string;
  content: string | null;
  type: string;
  channel: string | null;
  status: string;
  scheduled_date: string | null;
  sent_date: string | null;
  recipients_count: number;
  opened_count: number;
  clicked_count: number;
  created_by: string | null;
  created_at: string;
  updated_at: string;
}
